import { type ComponentProps } from 'react'
import { twMerge } from 'tailwind-merge'

interface SidepanelSectionHeaderProps extends ComponentProps<'div'> {}

export function SidepanelSectionHeader({ className, children, ...props }: SidepanelSectionHeaderProps) {
  return (
    // `group/section-header` is the hover source for everything that only exists
    // on hover — the View all action and the drag grip — and `relative` is what
    // both position against. The pill keeps the same `px-3` the header always
    // had, so the icon/label stay aligned with the rows in the section body.
    <div
      className={twMerge(
        'group/section-header hover:bg-element-hover corner-squircle relative flex h-7 w-full items-center rounded-[var(--radius-size-md)] px-3',
        className,
      )}
      {...props}
    >
      {children}
    </div>
  )
}

interface SidepanelSectionHeaderLeadProps extends ComponentProps<'div'> {}

/**
 * Left cluster that keeps the in-flow drag handle centered until the title
 * (icon + label + badge + chevron) would collide with it.
 *
 * `min-w-[calc(50%-0.625rem)]` is half the header minus half the grip
 * (`size-5` / 2). When the title is narrower, this still occupies that half so
 * the handle lands on the midpoint; when it's wider, the cluster grows and the
 * handle shifts right. `pr-2` is the minimum gap, including the chevron.
 */
export function SidepanelSectionHeaderLead({ className, children, ...props }: SidepanelSectionHeaderLeadProps) {
  return (
    <div
      className={twMerge('flex min-w-[calc(50%-0.625rem)] shrink-0 items-center self-stretch pr-2', className)}
      {...props}
    >
      {children}
    </div>
  )
}
